import { render, staticRenderFns } from "./ProFormaInvoicesListings.vue?vue&type=template&id=23126f62"
import script from "./ProFormaInvoicesListings.vue?vue&type=script&lang=js"
export * from "./ProFormaInvoicesListings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports